/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2025-03-20 20:14:54
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React from "react";
import isEqual from "lodash/isEqual";
import { BsyUtils } from "../../utils/Utils";
import BsyTextArea from "../BsyTextArea";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsySearchInput from "../BsySearchInput";
import BsyMsgBubble from "../BsyMsgBubble";

export default class BsyAddress extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-address",
      needDetail: !0,
      format: "pcda",
      allowBlank: !0,
      width: "100%",
      height: "auto",
      openMapAddress: true,
      seleceMapAddress: true,
      eventMode: 1,
      ...props,
    });

    let d = this.options;
    if (!d.format) {
      //兼容老的模式
      if (!d.needDetail) {
        d.format = "pcd";
      } else {
        d.format = "pcda";
      }
    }
    this.value = props.value;
    this.state = {
      value: props.value,
    };
    this.element = React.createRef();
    this.detailRef = React.createRef();
    this.getSearchResultItems();
  }

  getSearchResultItems = () => {
    let forobject = (items, prefixs) => {
      BsyUtils.forEach(items, (key, item) => {
        let curv = key;
        if (BsyUtils.isNumber(key)) {
          curv = item;
        }

        let prefix = prefixs.concat([curv]);
        let obj = {
          label: prefix.join("-"),
          value: prefix,
        };
        window.addressSearchResultItems.push(obj);
        forobject(item, prefixs.concat([curv]));
      });
    };

    if (!window.addressSearchResultItems) {
      window.addressSearchResultItems = [];
      forobject(window.chinaAddressData, []);
    }
  };

  getDetailContext = (context) => {
    this.detail = context;
  };

  setValue = (t) => {
    if (BsyUtils.isString(t)) {
      try {
        t = JSON.parse(t);
      } catch (error) {
        t = null;
      }
    }

    this.value = t;
    this.setState({
      value: t,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};

    if (!isEqual(nextProps.value, this.state.value)) {
      if (nextProps.value) {
        props.value = { ...nextProps.value };
        this.value = { ...nextProps.value };
      } else {
        props.value = { ...[] };
        this.value = { ...[] };
      }
      if (this.toItems) {
        props = {
          ...props,
          cityItems:
            nextProps.value && nextProps.value.province
              ? window.chinaAddressData[nextProps.value.province]
                ? this.toItems(
                    window.chinaAddressData[nextProps.value.province]
                  )
                : []
              : [],
          districtItems:
            nextProps.value && nextProps.value.province && nextProps.value.city
              ? window.chinaAddressData[nextProps.value.province] &&
                window.chinaAddressData[nextProps.value.province][
                  nextProps.value.city
                ]
                ? this.toItems(
                    window.chinaAddressData[nextProps.value.province][
                      nextProps.value.city
                    ]
                  )
                : []
              : [],
        };
      }
    }
    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props,
      });
    }
  }

  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    a.allowBlank || (b = !BsyUtils.isObjectEmpty(this.value));

    if (b && !a.allowBlank) {
      switch (a.format) {
        case "p": {
          b = !BsyUtils.isObjectEmpty(this.value.province);

          break;
        }

        case "pc": {
          b =
            !BsyUtils.isObjectEmpty(this.value.province) &&
            !BsyUtils.isObjectEmpty(this.value.city);
          break;
        }

        case "pcd": {
          b =
            !BsyUtils.isObjectEmpty(this.value.province) &&
            !BsyUtils.isObjectEmpty(this.value.city) &&
            !BsyUtils.isObjectEmpty(this.value.district);
          break;
        }
        case "pcda":
        default: {
          b =
            !BsyUtils.isObjectEmpty(this.value.province) &&
            !BsyUtils.isObjectEmpty(this.value.city) &&
            !BsyUtils.isObjectEmpty(this.value.district) &&
            !BsyUtils.isObjectEmpty(this.value.detail);
          if (this.detailRef.current) this.detailRef.current.checkValidate();
          break;
        }
      }
    }

    if (!this.isEnabled()) {
      b = !0;
      a.allowBlank || (b = !BsyUtils.isObjectEmpty(this.value));
    }

    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };

  getValue = () => {
    let value = this.value;
    BsyUtils.forEach(value, (a1, b1) => {
      if (!b1) {
        delete value[a1];
      }
    });

    if (!BsyUtils.isObjectEmpty(value)) {
      return value;
    }
    return null;
  };

  renderDisablePane = () => {
    const { format } = this.options;
    let value = this.getValue();
    let text = BsyUtils.address2Str(value, format, "-");
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
        ref={this.element}
      >
        {text}
      </div>
    );
  };

  showAddressPane = (event) => {
    const { value } = this.state;
    const { format, eventMode } = this.options;

    let that = this;
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        that.isChange = false;
        return (
          <ShowAddressPane
            format={format}
            value={value}
            onStopEdit={(value, occupy) => {
              that.value = {
                ...value,
                detail: that.state.value ? that.state.value.detail : null,
              };
              that.isChange = true;
              that.setState(
                {
                  value: {
                    ...value,
                    detail: that.state.value ? that.state.value.detail : null,
                  },
                },
                () => {
                  if (format === "p") {
                    if (value.province) {
                      ref.closeAlter();
                    }
                  } else if (format === "pc") {
                    if (value.province && value.city) {
                      ref.closeAlter();
                    }
                  } else if (format === "pcd" || format === "pcda") {
                    if (value.province && value.city && value.district) {
                      ref.closeAlter();
                    }
                  }
                  // that.props.onStopEdit(value, null, that)
                }
              );
            }}
          ></ShowAddressPane>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: "auto",
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function (e) {
        if (that.isChange) {
          if (eventMode == 1 || eventMode == 2) {
            that.props.onStopEdit(that.state.value, null, that);
          }
        }

        return !1;
      },
    });
  };

  _createDialog = (a) => {
    let that = this;
    var b = this,
      c = this.options,
      d = new window.FX.ConfirmDialog({
        title: React.language("only.select.Map.address"),
        width: 650,
        height: 530,
        contentWidget: {
          rowSize: [450],
          colSize: [610],
          hgap: 0,
          vgap: 15,
          padding: 15,
          items: [
            [
              {
                widgetName: "addressMap",
                value: b.getValue(),
                type: "addressmap",
              },
            ],
          ],
        },
        onOk: function () {
          var e = d.getWidgetByName("addressMap");
          if (e.checkValidate()) {
            var f = e.getValue();
            if (BsyUtils.isObjectEmpty(f)) {
              f = null;
            }
            b.setValue(f);

            // BsyUtils.applyFunc(b, c.onStopEdit, [f], !1)
            BsyUtils.applyFunc(b, c.onStopEdit, [f, null, that], !1);
            d.close();
          }
        },
      });
    d.show();

    var e = d.getWidgetByName("addressMap");
    e.setValue(this.value);
  };

  render() {
    let that = this;
    const { value } = this.state;
    const { cssName, css, format, seleceMapAddress, allowBlank, eventMode } =
      this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }
    let text = BsyUtils.address2Str(
      value,
      format === "pcda" ? "pcd" : format,
      "-"
    );
    return (
      <div className={cssName} ref={this.element} style={css}>
        <div style={{ display: "flex" }}>
          <div
            className="showContent"
            style={{ width: seleceMapAddress ? "calc( 100% - 42px )" : "100%" }}
            onClick={this.showAddressPane}
          >
            <span
              className={"value-text"}
              title={text}
              data-watermark={React.language("select.address")}
            >
              {text}
            </span>
            {this.renderBtn("icon-bsy-xia", value)}
          </div>
          {seleceMapAddress ? (
            <div
              className="seleceMapAddress"
              title={React.language("only.show5")}
              onClick={this._createDialog}
            >
              <i className="icon-location"></i>
            </div>
          ) : (
            ""
          )}
        </div>

        {format === "pcda" && (
          <BsyTextArea
            width={"auto"}
            height={60}
            customCls={"detail"}
            ref={this.detailRef}
            allowBlank={allowBlank}
            waterMark={React.language("widget.address.detail")}
            value={value ? value.detail : null}
            onAfterEdit={(e1) => {
              that.setState(
                {
                  value: { ...that.state.value, detail: e1 },
                  detail: e1 ? e1 : null,
                },
                () => {
                  that.value = this.state.value;
                }
              );
            }}
            onStopEdit={(e1) => {
              that.setState(
                {
                  value: { ...that.state.value, detail: e1 },
                  detail: e1 ? e1 : null,
                },
                () => {
                  that.value = this.state.value;
                  if (that.props.onStopEdit) {
                    if (eventMode == 1 || eventMode == 3) {
                      that.props.onStopEdit(this.state.value, null, this);
                    }
                  }
                }
              );
            }}
            getContext={this.getDetailContext}
          />
        )}
      </div>
    );
  }
}

export class ShowAddressPane extends BsyWidget {
  constructor(props) {
    super({
      minWidth: 100,
      baseCls: "bsy-show-address-pane",
      ...props,
    });

    this.value = props.value;
    const provinceItem = this.ByProvince();
    this.state = {
      seachKey: "",
      value: props.value ? { ...props.value } : {},
      provinceItems: provinceItem,
      cityItems:
        this.state.value && this.state.value.province
          ? window.chinaAddressData[this.state.value.province]
            ? this.toItems(window.chinaAddressData[this.state.value.province])
            : []
          : [],
      districtItems:
        this.state.value && this.state.value.province && this.state.value.city
          ? window.chinaAddressData[this.state.value.province] &&
            window.chinaAddressData[this.state.value.province][
              this.state.value.city
            ]
            ? this.toItems(
                window.chinaAddressData[this.state.value.province][
                  this.state.value.city
                ]
              )
            : []
          : [],
    };
  }

  ByProvince = () => {
    let provinceItem = [];
    BsyUtils.forEach(window.chinaAddressData, function (a) {
      provinceItem.push({
        value: a,
        text: a,
      });
    });
    return provinceItem;
  };

  linkByProvince = (a) => {
    if (!a) {
      this.setState(
        {
          value: null,
          provinceItem: [...this.ByProvince()],
          cityItems: [],
          districtItems: [],
        },
        () => {
          this.renderScrollTo();
          if (this.props.onStopEdit) {
            this.props.onStopEdit(this.state.value, null, this);
          }
        }
      );
    } else {
      let b = this.toItems(window.chinaAddressData[a.province]);
      this.setState(
        {
          value: { ...a },
          provinceItem: [...this.ByProvince()],
          cityItems: b,
          districtItems: [],
        },
        () => {
          this.renderScrollTo();
          this.value = this.state.value;
          if (this.props.onStopEdit) {
            this.props.onStopEdit(this.state.value, null, this);
          }
        }
      );
    }
  };
  toItems = (dd) => {
    let d = [];
    BsyUtils.forEach(dd, (a, b) => {
      if (Array.isArray(b)) {
        d.push({
          value: a,
          text: a,
        });
      } else {
        d.push({
          value: b,
          text: b,
        });
      }
    });
    return d;
  };
  linkByProvinceAndCity = (a) => {
    let c = window.chinaAddressData[a.province];
    if (c) {
      if (!a.city) {
        a.district = null;
        this.setState(
          {
            value: { ...a },
            districtItems: [],
          },
          () => {
            this.renderScrollTo();
            this.value = this.state.value;
            if (this.props.onStopEdit) {
              this.props.onStopEdit(this.state.value, null, this);
            }
          }
        );
      } else {
        let d = this.toItems(c[a.city]);
        a.district = null;
        this.setState(
          {
            value: { ...a },
            districtItems: d,
          },
          () => {
            this.renderScrollTo();
            this.value = this.state.value;
            if (this.props.onStopEdit) {
              this.props.onStopEdit(this.state.value, null, this);
            }
          }
        );
      }
    } else {
      this.setState(
        {
          value: { ...a },
          districtItems: [],
        },
        () => {
          this.value = this.state.value;
          if (this.props.onStopEdit) {
            this.props.onStopEdit(this.state.value, null, this);
          }
        }
      );
    }
  };

  componentDidMount() {
    super.componentDidMount();
    this.renderScrollTo();
  }

  selectItem = (item, type) => {
    const { value } = this.state;
    let val = null;
    if (value && value[type]) {
      val = value[type];
    }
    if (!val) {
      return "";
    }
    if (item.text === val) {
      return "selected";
    }
    return "";
  };

  renderScrollTo = () => {
    this.scrollTop = this.scrollTop || {};
    if (this.scrollTop.province) {
      let res = this.element.current.querySelector(".menu-items.province");
      if (res) {
        res.scrollTop = this.scrollTop.province * 32;
      }
    }
    if (this.scrollTop.city) {
      let res = this.element.current.querySelector(".menu-items.city");
      if (res) {
        res.scrollTop = this.scrollTop.city * 32;
      }
    }
    if (this.scrollTop.district) {
      let res = this.element.current.querySelector(".menu-items.district");
      if (res) {
        res.scrollTop = this.scrollTop.district * 32;
      }
    }

    var ret = BsyUtils.closestClass(this.element.current, "bsy-msg-bubble");
    if (ret) {
      let offset = BsyUtils.elemoffset(ret);
      let width = ret.offsetWidth;
      if (width + offset.left > document.body.clientWidth) {
        ret.style.left = "auto";
        ret.style.right = 0;
      }
    }
  };

  onClick = (items, type) => {
    switch (type) {
      case "province": {
        this.linkByProvince({
          province: items.value,
        });
        break;
      }
      case "city": {
        this.linkByProvinceAndCity({
          ...this.state.value,
          city: items.value,
        });
        break;
      }
      case "district": {
        this.setState(
          {
            value: { ...this.state.value, district: items.value },
            district: items.value,
          },
          () => {
            this.renderScrollTo();
            this.value = this.state.value;
            if (this.props.onStopEdit) {
              this.props.onStopEdit(this.state.value, null, this);
            }
          }
        );
        break;
      }
      default: {
        break;
      }
    }
  };

  selectSeachItem = (item) => {
    let val = {};
    switch (item.value.length) {
      case 1: {
        val.province = item.value[0];
        break;
      }
      case 2: {
        val.province = item.value[0];
        val.city = item.value[1];
        break;
      }
      case 3: {
        val.province = item.value[0];
        val.city = item.value[1];
        val.district = item.value[2];
        break;
      }
      default:
    }

    this.setState(
      {
        value: { ...val },
        province: val.province ? val.province : null,
        city: val.city ? val.city : null,
        district: val.district ? val.district : null,
      },
      () => {
        this.value = this.state.value;
        if (this.props.onStopEdit) {
          this.props.onStopEdit(this.state.value, null, this);
        }
      }
    );
  };

  renderItems = (items, type) => {
    this.scrollTop = this.scrollTop || {};
    this.scrollTop[type] = 0;

    return (
      <div className={"menu-items " + type}>
        {items.map((e, index) => {
          let css = this.selectItem(e, type);
          if (css) {
            this.scrollTop[type] = index;
          }
          return (
            <div
              className={"item " + css}
              onClick={(event) => {
                this.onClick(e, type);
              }}
            >
              <span className="label">{e.text}</span>
              <i className="icon-bsy-right"></i>
            </div>
          );
        })}
      </div>
    );
  };

  findResultItems = () => {
    const { seachKey } = this;
    const { format } = this.options;
    let result = [];
    if (seachKey) {
      result = window.addressSearchResultItems.filter((elm) => {
        if (format == "p") {
          if (elm.value.length == 1) {
            return elm.label.indexOf(seachKey) > -1;
          }
        } else if (format == "pc") {
          if (elm.value.length == 2) {
            return elm.label.indexOf(seachKey) > -1;
          }
        } else {
          return elm.label.indexOf(seachKey) > -1;
        }
      });
    }
    this.setState({
      resultItem: result,
    });
  };

  render() {
    const { cssName, format } = this.options;
    const { provinceItems, cityItems, districtItems, value, resultItem } =
      this.state;
    const { seachKey } = this;
    return (
      <div className={cssName} ref={this.element}>
        <div className={"search-wrapper"}>
          <BsySearchInput
            styleInput={{
              width: "100%",
            }}
            placeholder={React.language("search.data")}
            onSearch={(e) => {
              this.seachKey = e ? e.trim() : "";
              this.findResultItems();
            }}
            type={window.mode}
            // iconName="icon-bsy-reportmenu-0"
          ></BsySearchInput>
        </div>

        {seachKey ? (
          <div className="content-wrapper-list">
            {resultItem.length == 0 ? (
              <div className="result-empty">
                {React.language("address.seach.empty")}
              </div>
            ) : (
              resultItem.map((e) => {
                let text = BsyUtils.highlighterText(seachKey, e.label);
                return (
                  <div
                    className="result-item"
                    title={e.label}
                    onClick={(event) => {
                      this.selectSeachItem(e);
                    }}
                  >
                    {text}
                  </div>
                );
              })
            )}
          </div>
        ) : (
          <div className="content-wrapper">
            {this.renderItems(provinceItems, "province")}
            {(format === "pc" || format === "pcd" || format === "pcda") &&
            value &&
            value.province && !BsyUtils.isObjectEmpty(cityItems) 
              ? this.renderItems(cityItems, "city")
              : ""}
            {(format === "pcd" || format === "pcda") &&
            value &&
            value.province &&
            value.city && !BsyUtils.isObjectEmpty(districtItems) 
              ? this.renderItems(districtItems, "district")
              : ""}
          </div>
        )}
      </div>
    );
  }
}
